import useMediaQuery from "@/features/shared/hooks/use-media-query";

/**
 * Below this viewport width the map editor's main tab rail switches from the
 * vertical sidebar to a horizontal scrollable rail (the same breakpoint the
 * time-series configurator uses for its tab orientation).
 */
const DESKTOP_MEDIA = "(min-width: 800px)";

export interface MapPanelTabLayout {
  /** True on narrow/mobile viewports, where the rail sits horizontally on top. */
  horizontal: boolean;
  orientation: "vertical" | "horizontal";
  /** "rail" is the compact scrollable style used for the horizontal layout. */
  variant: "tabs" | "rail";
}

/**
 * Resolves the main widget-editor tab rail layout: a vertical sidebar of pill
 * tabs on desktop, collapsing to a horizontal scrollable rail on mobile. Shared
 * by the obs-map and model-map editors so both switch identically.
 */
export function useMapPanelTabLayout(): MapPanelTabLayout {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA);
  return {
    horizontal: !isDesktop,
    orientation: isDesktop ? "vertical" : "horizontal",
    variant: isDesktop ? "tabs" : "rail",
  };
}
